import React, { useLayoutEffect, useRef } from 'react';

/* A .textarea that grows with its content instead of scrolling. */
export default function AutoTextarea({ value, minRows = 3, className = 'textarea', style, ...rest }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [value]);

  return (
    <textarea
      ref={ref}
      rows={minRows}
      value={value}
      className={className}
      style={{ overflow: 'hidden', resize: 'none', ...style }}
      {...rest}
    />
  );
}
